import * as AuthenticationWebService from '../webServices/AuthenticationWebService.js';
import { Unauthorized } from '../exceptions';
import LoginStatusType from '../objects/LoginStatusType.js';
import store from '../store';

function ProcessSpec(spec) {
  if ((spec.access_token || '') === '') {
    if ((spec.refresh_token || '') === '') {
      return LoginStatusType.Failed;
    }
    store.dispatch('setLoginStatus', { refreshToken: spec.refresh_token });
    return LoginStatusType.AlreadyLogin;
  }

  store.dispatch('setLoginStatus', { refreshToken: spec.refresh_token, accessToken: spec.access_token });
  return LoginStatusType.Success;
}

function ProcessUnauthorized(data) {
  let status = LoginStatusType.Failed;
  const refreshToken = data.refresh_token;
  if (Object.prototype.hasOwnProperty.call(data, 'expired')) {
    // 密碼過期
    status = LoginStatusType.PasswordExpired;
    status.SetData({
      expired: data.expired, allowLogin: (refreshToken || '') !== '', tempToken: data.temp_token, account: data.account
    });
  } else if (Object.prototype.hasOwnProperty.call(data, 'times')) {
    // 帳號鎖定
    status = LoginStatusType.AccountLocked;
    status.SetData({ times: data.times });
  } else if ((refreshToken || '') !== '') {
    // 重複登入
    status = LoginStatusType.AlreadyLogin;
  }

  if ((refreshToken || '') !== '') {
    store.dispatch('setLoginStatus', { refreshToken });
  }

  return status;
}

export async function LoginAsync(account, password, captcha) {
  let status = LoginStatusType.Failed;
  try {
    const spec = await AuthenticationWebService.LoginAsync(account, password, captcha) || {};
    status = ProcessSpec(spec);
  } catch (e) {
    store.dispatch('initialLoginStatus');
    if (e instanceof Unauthorized) {
      status = ProcessUnauthorized(e.data);
    }
  }
  return status;
}

export async function RefreshAsync() {
  let status = LoginStatusType.Failed;
  const { refreshToken } = store.getters;
  if ((refreshToken || '') !== '') {
    try {
      const spec = await AuthenticationWebService.RefreshAsync(refreshToken) || {};
      status = ProcessSpec(spec);
    } catch (e) {
      // 換token失敗，不會做清除的動作
      // store.dispatch('initialLoginStatus');
      // if (e instanceof Unauthorized) {
      //   status = ProcessUnauthorized(e.data);
      // }
    }
  }

  if (status.code !== LoginStatusType.Success.code) {
    store.commit('setLogoutStatus', status);
  }

  return status;
}

export async function IssueTempAsync(tempToken) {
  return await AuthenticationWebService.IssueTempAsync(tempToken) || {};
}

export async function VerifyAsync() {
  let status = LoginStatusType.Failed;
  const { accessToken } = store.getters;
  if ((accessToken || '') !== '') {
    try {
      await AuthenticationWebService.VerifyAsync(accessToken);
      status = LoginStatusType.Success;
    } catch (e) {
      if (e instanceof Unauthorized) {
        status = await RefreshAsync();
      }
    }
  }
  return status;
}

export async function LogoutAsync() {
  const { accessToken } = store.getters;
  try {
    if ((accessToken || '') !== '') {
      await AuthenticationWebService.LogoutAsync(accessToken);
    }
  } catch (e) {
    // 不額外處理
  } finally {
    store.dispatch('initialLoginStatus');
  }
}

/**
 * 撤銷 Token
 */
export async function RevokeAsync(token) {
  let accessToken = token;
  if ((accessToken || '') === '') {
    accessToken = store.getters.accessToken;
  }
  try {
    if ((accessToken || '') !== '') {
      await AuthenticationWebService.RevokeAsync(accessToken);
    }
  } catch (e) {
    // 不額外處理
  }
}
